/* ==========================================================================
   Sura – banner rail
   Chevron navigation for the horizontal banner track.
   The buttons are CSS-hidden above 1199px; this only drives their state.
   ========================================================================== */

(function () {
  if (customElements.get('sura-rail')) return;

  const EDGE = 2; // px tolerance when testing "at the start / at the end"

  class SuraRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sura-rail__track');
      if (!this.track) return;

      this.nav = this.querySelector('.sura-rail__nav');
      this.prevBtn = this.querySelector('[data-rail-dir="prev"]');
      this.nextBtn = this.querySelector('[data-rail-dir="next"]');
      if (!this.nav) return;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.handleScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.refresh();
        });
      };

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.step(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.step(1));

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.refresh());
        this.ro.observe(this.track);
      } else {
        window.addEventListener('resize', this.handleScroll);
      }

      // Images settle late; re-measure once they have loaded.
      this.handleLoad = () => this.refresh();
      window.addEventListener('load', this.handleLoad);

      this.refresh();
    }

    disconnectedCallback() {
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this.handleScroll);
      window.removeEventListener('load', this.handleLoad);
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    refresh() {
      const max = this.maxScroll;
      const overflowing = max > EDGE;

      this.nav.hidden = !overflowing;
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= EDGE;
      if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max - EDGE;
    }

    /* One page = as many whole cards as currently fit in the scrollport. */
    pageSize() {
      const item = this.track.querySelector('.sura-rail__item');
      if (!item) return this.track.clientWidth;

      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap) || 0;
      const inset =
        (parseFloat(styles.paddingInlineStart) || 0) + (parseFloat(styles.paddingInlineEnd) || 0);
      const column = item.getBoundingClientRect().width + gap;
      const visible = Math.max(0, this.track.clientWidth - inset);
      const perView = Math.max(1, Math.floor((visible + gap) / column));

      return column * perView;
    }

    step(direction) {
      const max = this.maxScroll;
      const target = this.track.scrollLeft + this.pageSize() * direction;

      this.track.scrollTo({
        left: Math.max(0, Math.min(max, target)),
        behavior: this.motionQuery.matches ? 'auto' : 'smooth',
      });
    }
  }

  customElements.define('sura-rail', SuraRail);
})();
